<div class="page-content" *ngIf="!timerService.isForwarding">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page_title" translate>{{'transition_2.page_title'}}</h1>

     <information outer-style="width:100%">

          <h2 translate>{{'transition_2.you_have_completed'}}</h2>

          <div class="service-item">
               <div class="service-confirm left-w4">
                    <img src="refresh/assets/images/confirm-blue.png" width="30" height="30"/>
               </div>
               <div class="service-text right-w91">
                   <div>
                        <strong translate='transition_2.register_birth.title' class="service-title"></strong>
                   </div>
                   <div translate='transition_2.register_birth.description' class="service-body"></div>
               </div>
          </div>
          <div class="service-item" [hidden] = "!(orderOfBC.hasBCWithParentInfo == 'Y' || 
                    orderOfBC.hasBirthCertificate == 'Y' || 
                    orderOfBC.hasCertifiedCopyOfBR == 'Y')">
               <div class="service-confirm left-w4">
                    <img src="refresh/assets/images/confirm-blue.png" width="30" height="30"/>
               </div>
               <div class="service-text right-w91">
               <div>
                    <strong translate='transition_2.order_birth_certificate.title' class="service-title"></strong>
               </div>
               <div class="service-body" translate='transition_2.order_birth_certificate.description'></div>
               <div class="service-body" [innerHTML]="'transition_2.order_birth_certificate.note' | translate"></div>
               </div>
          </div>   
     
          <div class="service-item" [hidden] = "(orderOfBC.hasBCWithParentInfo == 'Y' || 
                    orderOfBC.hasBirthCertificate == 'Y' || 
                    orderOfBC.hasCertifiedCopyOfBR == 'Y')">
               <div class="service-confirm left-w5">
                     <img src="refresh/assets/images/ontario-icon-alert-error.png" width="34" height="34"/> 
               </div>
               <div class="service-text right-w91">
                    <div>
                         <strong translate='transition_2.order_birth_certificate.title' class="service-title"></strong>
                    </div>
                    <div translate='transition_2.order_birth_certificate.opt_out' class="service-body"></div>
               </div>
          </div>  

          <div [hidden]="!noException()">
               <h2 translate>{{'transition_2.next_you_can.title'}}</h2>
               <div class="service-item">
                    <div class="service-confirm left-w5"><img src="assets/images/confirm.png"/></div>
                    <div class="service-text right-w91">
                        <strong translate='transition_2.next_you_can.additional_services.title' class="service-title"></strong>
                        <div class="service-body" translate='transition_2.next_you_can.additional_services.description'></div>
                    </div>
               </div>  
          </div>

          <div [hidden]="!childDeceased()">
               <h2 translate>{{'transition_2.next_you_can.title'}}</h2>
               <div class="service-item">
                    <div class="service-confirm left-w5"><img src="assets/images/confirm.png"/></div>
                    <div class="service-text right-w91">
                        <strong translate='transition_2.next_you_can.additional_services.title' class="service-title"></strong>
                        <div class="service-body" translate='transition_2.next_you_can.additional_services.description_ccb'></div>
                    </div>
               </div>   
          </div>
     </information>

     <div class="btn-div">
          <div><button class="btn-next" title="{{Button.Next_alt|translate}}" (click)="onNextClick()" translate>{{Button.Next}}</button></div>
     </div>

     <div [hidden]="eligibility.isCustodyOtherThanParent == 'Y'">
          <div class="flex-center accord-body">
               <span></span>
               <accordion header="transition_2.accordion.header" translate tabindex="0" outer-class="accord-width29">
                    <div translate>{{'transition_2.accordion.content1'}}</div>
                    <div class="accordion-padding-inner" translate>{{'transition_2.accordion.content2'}}</div>
               </accordion>
               <span></span>
          </div>
          <br/>
     </div>
</div>


<!--   width:29em -->